<template>
<v-container>
    <v-dialog
      v-model="covidNotify"
      persistent :overlay="false"
    >
      <v-card >
        <v-toolbar color="accent" dark class="title" flat>
          <v-icon left>fas fa-exclamation-circle</v-icon>
          PLEASE BE AWARE
        </v-toolbar>
        <v-container fluid>
          <v-row dense>
            <v-col cols="12" class="subtitle-1 text-center">
              Please be aware that due to current conditions surrounding the COVID-19 pandemic all requests are <b>tentative</b>. We will do our best to keep everyone up to date as any state guidelines change. 
            </v-col>
            <v-col cols="12" class="subtitle-1 text-center">
              Currently all events taking place at The Mount campus are <a href="https://drive.google.com/file/d/1pTs2BEdb1ScT4IhyIjpF6shks90miL0i/view?usp=sharing" target="_blank" class="accent--text">subject to the following guidelines.</a>
            </v-col>
            <v-col cols="12" class="subtitle-1 text-center">
              Thank you for your understanding as we navigate these challenges.
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" class="text-right">
              <v-btn outlined color="secondary" @click="$emit('closeCovid')">Got it!</v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
  export default {
    props: {
      covidNotify: Boolean
    }
  }
</script>
